var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 89 89",
    style: {
      enableBackground: "new 0 0 89 89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FCBC00;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.5,70.5c-3.9-8.2-7.8-16.3-11.7-24.5c7.8,0,15.5,0,23.3,0C52.3,54.2,48.4,62.3,44.5,70.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.7,44.2c-7.5,0-15,0-22.5,0c3.8-4.8,7.5-9.6,11.3-14.4C48.3,34.6,52,39.4,55.7,44.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41,67.7c-7.6-7.9-15.2-15.9-22.8-23.8c0,0,0-0.1,0.1-0.1c1,0.2,2.1,0.3,3.1,0.5c3,0.5,6,1,9,1.5 c0.2,0,0.5,0.2,0.6,0.4c3.4,7,6.7,14,10,21C41.1,67.4,41.1,67.5,41,67.7C41.1,67.7,41.1,67.7,41,67.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.8,43.8c-7.7,8-15.3,15.9-22.9,23.8c0,0-0.1,0-0.1,0c0-0.1,0.1-0.2,0.1-0.4c3.3-7,6.7-14,10-21 c0.2-0.3,0.4-0.4,0.7-0.5c4-0.7,7.9-1.3,11.9-2C70.6,43.8,70.7,43.8,70.8,43.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.6,44.1c0.4-4.6,0.7-9.1,1.1-13.8c4,3.9,7.9,7.7,11.8,11.6C67.2,42.6,62.9,43.3,58.6,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.4,44.1c-4.3-0.7-8.6-1.4-12.9-2.2c4-3.9,7.8-7.7,11.8-11.6C29.7,35,30.1,39.5,30.4,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.3,29.2c3.9,0,7.7,0,11.6,0c-0.4,4.5-0.7,8.9-1.1,13.5C53.3,38.2,49.8,33.7,46.3,29.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31,29.2c3.9,0,7.7,0,11.6,0c-3.5,4.5-7,8.9-10.4,13.4c0,0-0.1,0-0.1,0C31.8,38.2,31.4,33.7,31,29.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.7,18.4c3.2,0.8,5.1,2.8,5.7,5.9c0.7-3.1,2.6-5.1,5.8-5.9c-1.6-0.3-2.8-1-3.9-2.1c-1-1.1-1.7-2.3-1.9-3.8 C27.8,15.6,25.9,17.5,22.7,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.3,22.8c2.6,0.7,4.2,2.3,4.8,4.9c0.6-2.6,2.1-4.2,4.8-4.9c-1.3-0.3-2.3-0.9-3.2-1.7 c-0.9-0.9-1.4-1.9-1.6-3.1C37.5,20.5,36,22.1,33.3,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.1,26.4c2.6,0.7,4.2,2.3,4.8,4.9c0.6-2.6,2.1-4.2,4.8-4.9c-1.3-0.3-2.3-0.9-3.2-1.7 c-0.9-0.9-1.4-1.9-1.6-3.1C23.3,24.1,21.7,25.7,19.1,26.4z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.2539db9d0fa75e1f5a9be7f4e82d2247.svg";
export { ForwardRef as ReactComponent };